(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const videoBanner = {
      init() {
        this.video = document.querySelector('.video-banner__video');
        this.fallback = document.querySelector('.video-banner__fallback');

        if (!this.video) return;

        const markPlaying = () => this.video.classList.add('is-playing');
        this.video.addEventListener('playing', markPlaying);
        if (!this.video.paused && this.video.readyState > 2) markPlaying();

        // Reduced motion: hold on the poster, never the animated fallback
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        this.setupVideoPlayback();
        this.handleNetworkChange();
      },

      setupVideoPlayback() {
        const playPromise = this.video.play();
        if (playPromise === undefined) return;

        playPromise.catch((error) => {
          // AbortError: the play() was interrupted by the video still loading, not refused.
          // Retry once it can play; only a second failure counts as blocked.
          if (error && error.name === 'AbortError') {
            const retry = () => this.video.play().catch((retryError) => this.handleBlocked(retryError));
            if (this.video.readyState >= 3) retry();
            else this.video.addEventListener('canplay', retry, { once: true });
            return;
          }
          this.handleBlocked(error);
        });
      },

      handleBlocked(error) {
        // Autoplay refused (NotAllowedError): GIF fallback, and a tap can still start the video
        console.warn('Video playback failed:', error);
        this.switchToFallback();
        this.playOnTap();
      },

      playOnTap() {
        const banner = this.video.closest('.video-banner');
        const onTap = (event) => {
          if (event.target.closest('a')) return;
          banner.removeEventListener('click', onTap);
          this.video.style.display = '';
          if (this.fallback) this.fallback.style.display = '';
          this.video.play().catch(() => this.switchToFallback());
        };
        banner.addEventListener('click', onTap);
      },

      handleNetworkChange() {
        if ('connection' in navigator) {
          navigator.connection.addEventListener('change', () => {
            if (
              navigator.connection.saveData ||
              navigator.connection.effectiveType === 'slow-2g' ||
              navigator.connection.effectiveType === '2g'
            ) {
              // Data saver: stop the video and skip the heavy GIF
              this.video.pause();
            }
          });
        }
      },

      switchToFallback() {
        this.video.pause();

        const { srcMobile, srcDesktop } = this.fallback ? this.fallback.dataset : {};
        const src = window.matchMedia('(max-width: 768px)').matches
          ? srcMobile || srcDesktop
          : srcDesktop || srcMobile;
        // No GIF: the poster stays up, with a play button so it doesn't read as a still image
        if (!src) {
          if (window.addVideoPlayButton) window.addVideoPlayButton(this.video, this.video.closest('.video-banner'));
          return;
        }

        // Keep the poster up until the GIF has loaded, then swap
        const show = () => {
          if (!this.video.paused) return;
          this.video.style.display = 'none';
          this.fallback.style.display = 'block';
        };
        if (this.fallback.complete && this.fallback.getAttribute('src')) {
          show();
        } else {
          this.fallback.addEventListener('load', show, { once: true });
          if (!this.fallback.getAttribute('src')) this.fallback.src = src;
        }
      },
    };

    videoBanner.init();
  });

  } catch(e) { console.error(e); }
})();
})();
